<template>
  <v-container>
    <v-row
      v-if="!isLoggedIn"
      align-center
      justify-center
    >
      <v-col
        cols="12"
        alignment="center"
        justify="center"
        class="mx-auto pt-0"
        sm="8"
        md="7"
        lg="6"
        xl="4"
      >
        <v-card
          color="white"
          align-center
        >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-card-title class="justify-center">
              <h3
                class="headline mb-0"
              >
                <span v-if="!authenticationFailure">
                  <span v-if="!forgotPasswordMode && !loginIn">Log ind</span>
                  <span v-if="forgotPasswordMode">Nulstil password</span>
                  <span v-if="loginIn">...logger ind</span>
                </span>
                <span
                  v-else
                  class="red--text"
                  style="word-break: normal; hyphens: auto;"
                >{{ authenticationFailureMessage }}</span>
              </h3>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="email"
                :disabled="loginIn"
                autofocus
                autocomplete="new-password"
                prepend-icon="mdi-account"
                name="email"
                label="Email"
                type="email"
                :rules="emailRules"
                data-cy="signInEmailField"
                required
              />
              <v-text-field
                v-if="!forgotPasswordMode"
                v-model="password"
                :disabled="loginIn"
                autocomplete="new-password"
                prepend-icon="mdi-lock"
                name="password"
                label="Password"
                type="password"
                required
                :rules="passwordRules"
                data-cy="signInPasswordField"
              />
              <p
                v-if="forgotPasswordMode"
                class="mt-3 ml-4 text-xs-left"
              >
                Du vil modtage et link til at nulstille dit password på denne email adresse.
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-show="!forgotPasswordMode"
                text
                @click="changeToForgotPasswordMode"
              >
                glemt password?
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="forgotPasswordMode"
                color="secondary"
                data-cy="cancelForgotPasswordBtn"
                @click="cancelForgotPasswordMode"
              >
                annuller
              </v-btn>
              <v-btn
                type="submit"
                color="primary"
                :disabled="!valid || wrongUserNameOrPass"
                :loading="loading"
                data-cy="signinSubmitBtn"
                @click.stop="submit"
              >
                <span v-if="!forgotPasswordMode">log ind</span>
                <span v-else>nustil password</span>
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-else
      align-center
      justify-center
      mb-4
    >
      <v-btn
        outlined
        data-cy="logout"
        @click="logout"
      >
        log ud
      </v-btn>
    </v-row>

    <v-row
      row
      justify-center
    >
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            Tjek din mail
          </v-card-title>

          <v-card-text>
            <span>
              Et password reset link er sendt til
              <span class="font-weight-bold">{{ email }}</span>
            </span>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success"
              @click.stop="passwordDialogacknowledged()"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
// import { mapGetters } from 'vuex'

import { auth } from '../../../auth/auth'
import { AuthenticationError, AuthErrorCode } from '../../../auth/authenticationError'
import { vxm } from '../../../state/index'

export default {
  name: 'LoginForm',
  data() {
    return {
      forgotPasswordMode: false,
      loading: false,
      loginIn: false,
      wrongUserNameOrPass: false,
      authenticationFailure: false,
      authenticationFailureMessage: 'e',
      valid: false,
      dialog: false,
      email: '',
      password: '',
      emailRules: [(v) => !!v || 'E-mail skal udfyldes',
        (v) => /.+@.+/.test(v) || 'Skriv venligst en gyldig e-mail adresse'],
      passwordRules: [(v) => !!v || 'Password skal udfyldes',
        (v) => v.length >= 6 || 'Passwordet består af mindst 6 tegn'],
    }
  },
  computed: {

    isLoggedIn() {
      return vxm.authUser.isLoggedIn
    },
  },
  watch: {
    email: {
      handler() {
        this.clearWrongUserNameOrPass()
      },
    },
    password: {
      handler() {
        this.clearWrongUserNameOrPass()
      },
    },
    isLoggedIn: {
      // prevent the form from storing username / pass if it is still in the dom, but not shown
      handler(isLoggedIn) {
        if (isLoggedIn) {
          this.email = ''
          this.password = ''
        }
      },
    },
  },
  methods: {
    passwordDialogacknowledged() {
      this.dialog = false
      this.forgotPasswordMode = false
    },
    clearWrongUserNameOrPass() {
      this.authenticationFailure = false
      this.wrongUserNameOrPass = false
    },
    changeToForgotPasswordMode() {
      this.forgotPasswordMode = true
      this.$refs.form.validate()
    },
    cancelForgotPasswordMode() {
      this.forgotPasswordMode = false
      this.loading = false
    },
    handleAuthFailure(errCode) {
      let msg = 'fejl'
      switch (errCode) {
      case AuthErrorCode['invalid-email']:
        msg = 'Email adressen er ugyldig! prøv igen!'
        this.wrongUserNameOrPass = true
        break
      case AuthErrorCode['user-disabled']:
        msg = 'Du kan ikke logge ind med denne konto (kontoen er deaktiveret).'
        this.wrongUserNameOrPass = true
        break
      case AuthErrorCode['user-not-found']:
        msg = 'Der er ingen bruger med denne emailadresse!'
        this.wrongUserNameOrPass = true
        break
      case AuthErrorCode['wrong-password']:
        msg = 'Forkert password! prøv igen!'
        this.wrongUserNameOrPass = true
        break
      case AuthErrorCode['request-timeout']:
        msg = 'Ups... serveren svarede ikke. Prøv igen! Kontakt os, hvis problemet vedbliver.'
        break
      case AuthErrorCode['too-many-requests']:
        msg = 'Whoa... slow down :-) For mange login forsøg. Prøv igen om lidt!'
        break
      case AuthErrorCode['unknown-server-error']:
        msg = 'Ups... der opstod en fejl på serveren! prøv igen! '
          + 'Kontakt os, hvis problemet vedbliver.'
        break
      case AuthErrorCode.other:
        msg = 'Ups... der opstod en fejl! prøv igen! Kontakt os, hvis problemet vedbliver.'
        break
      default:
        msg = 'Ups... der opstod en ukendt fejl! prøv igen! Kontakt os, hvis problemet vedbliver.'
      }
      this.authenticationFailureMessage = msg
      this.authenticationFailure = true
    },

    async submit(e) {
      e.preventDefault()
      if (this.$refs.form.validate()) {
        this.loading = true
        this.authenticationFailure = false

        if (this.forgotPasswordMode) {
          this.password = ''
          await auth.sendPasswordResetEmail(this.email)
            .then(() => { this.dialog = true })
            .catch((err) => {
              if (err instanceof AuthenticationError) {
                this.handleAuthFailure(err.code)
              } else {
                this.handleAuthFailure('unknown')
              }
            })
          this.loading = false
        } else {
          this.loginIn = true
          await auth.signIn(this.email, this.password)
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .then(() => {
            })
            .catch((err) => {
              if (err instanceof AuthenticationError) {
                this.handleAuthFailure(err.code)
              } else {
                this.handleAuthFailure('unknown')
              }
            })
          this.loading = false
          this.loginIn = false
        }
        // console.log(resp)
      }
    },
    logout() {
      auth.signOut()
    },
  },
}

</script>

<style scoped></style>
